import { render } from "./PackingSlipsTabs.vue?vue&type=template&id=2745c910&scoped=true"
import script from "./PackingSlipsTabs.vue?vue&type=script&lang=js"
export * from "./PackingSlipsTabs.vue?vue&type=script&lang=js"

import "./PackingSlipsTabs.vue?vue&type=style&index=0&id=2745c910&lang=scss&scoped=true"

import exportComponent from "/opt/approot/build.20241112-151327-1a92bd59/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2745c910"]])

export default __exports__